import { useState, useEffect, useCallback } from 'react';

export function useFormDirty(open: boolean) {
  const [isDirty, setIsDirty] = useState(false);

  useEffect(() => {
    if (!open) setIsDirty(false);
  }, [open]);

  const markDirty = useCallback(() => { setIsDirty(true); }, []);

  return { isDirty, setIsDirty, markDirty } as const;
}
